<template>
  <div>
    <v-row justify="center" class="" no-gutters>
      <v-col xl="9" lg="11" md="11" sm="12" cols="12">
        <v-row justify="center" class="xl-4 lg-4 pt-xl-4 pt-lg-4 pt-md-4 pb-xl-12 pb-lg-12 pb-md-8 pb-sm-4 pb-4 mt-xl-4 mt-lg-4 mt-md-4" no-gutters>
          <v-col class="pr-3" cols="3" v-if="$vuetify.breakpoint.mdAndUp">
            <v-skeleton-loader v-for="i in 5" type="list-item-two-line" tile :key="i + '_filter'"></v-skeleton-loader>
          </v-col>
          <v-col class="pl-xl-5 pl-lg-5 pl-md-5" xl="9" lg="9" md="9" sm="12" cols="12">
            <v-skeleton-loader v-for="i in 10" type="list-item-avatar-three-line" tile :key="i + '_item'"></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'SearchLoader'
}
</script>
